import React, { useState, useEffect} from "react"
import api from '../api'
import { gotoURL, chk_img, lang } from '../lang'
import FilterComponent from "./FilterComponent";

export default function Place(props) {
    const [header_font, setHeaderFont] = useState("galyani !text-5xl");
    const styles = props.styles;
    const [all_data, setAllData] = useState([]);
    const [listsdata, setListsdata] = useState([]);
    const [filterText, setFilterText] = useState('');
    const [page, setPage] = useState(1);
    const show = 6;
    const [all_province, setAllProvince] = useState([]);

    const fetchInit = async () =>{
        try {
            await fetch(
                "https://services.library.cmu.ac.th/api/api_province_with_amphure_tambon.json"
                )
                .then((response) => response.json())
                .then((result) => {
                    setAllProvince(result);
                });
        } catch (err) {
            if(err.response){
                //Not in 202 response range
                console.log(err.response.data);
                console.log(err.response.headers);
                console.log(err.response.status);
            } else {
                console.log(`Error: ${err.message}`);
            }
        }
    }

    useEffect(()=>{
        const init = JSON.parse(localStorage.getItem("lannainfo_init"));
        const home_config = JSON.parse(init.config);

        if(home_config.header_font==='Princess Galyani Vadhana IM'){
            setHeaderFont("galyani !text-5xl");
        }else if(home_config.header_font==='Kanit'){
            setHeaderFont("kanit");
        }else if(home_config.header_font==='TH Sarabun New'){
            setHeaderFont("sarabun");
        }else if(home_config.header_font==='Saruns2477'){
            setHeaderFont("saruns");
        }else if(home_config.header_font==='Pudgrong'){
            setHeaderFont("pudgrong");
        }else{
            setHeaderFont("sans-serif");
        }
        fetchInit();
        fetchData();
  },[]);

  const fetchData = async () =>{
    try {
      const response = await api.get('/place');
      let results = response.data.results;
      setAllData(results);
      setListsdata(results);
    } catch (err) {
        if(err.response){
            //Not in 202 response range
            console.log(err.response.data);
            console.log(err.response.headers);
            console.log(err.response.status);
        } else {
            console.log(`Error: ${err.message}`);
        }
    }
  }

  const onFilter = (txt,province,district) => {  
    let filteredItems = all_data.filter(
        item => item.id.includes(txt.toLowerCase()) || 
                item.name.toLowerCase().includes(txt.toLowerCase()) || 
                item.address.toLowerCase().includes(txt.toLowerCase()) || 
                item.address_en.toLowerCase().includes(txt.toLowerCase()) || 
                item.detail.toLowerCase().includes(txt.toLowerCase()) || 
                item.detail_en.toLowerCase().includes(txt.toLowerCase()) || 
                item.type_name.toLowerCase().includes(txt.toLowerCase()) || 
                item.era_name.toLowerCase().includes(txt.toLowerCase()),
    );

    if(txt===''){
        filteredItems = all_data;
    }
    if(province&&province!==''){
        filteredItems = filteredItems.filter(item=>(parseInt(item.province)===parseInt(province)||parseInt(item.main_location_province)===parseInt(province)))
        // console.log("1");
        // console.log(filteredItems,province,district)
    }

    if(district&&district!==''){
        filteredItems = filteredItems.filter(item=>(parseInt(item.district)===parseInt(district)||parseInt(item.main_location_district)===parseInt(district)))
        // console.log("2");
        // console.log(filteredItems,district)
    }
    setListsdata(filteredItems);
    setFilterText(txt);
  }
  /* filter and clearfilter */
  const handleClear = () => {
      const txt = '';
      const filteredItems = all_data.filter(
          item => item.id.includes(txt.toLowerCase()) || 
          item.name.toLowerCase().includes(txt.toLowerCase()) || 
          item.address.toLowerCase().includes(txt.toLowerCase()) || 
          item.district.toLowerCase().includes(txt.toLowerCase()) || 
          item.sub_district.toLowerCase().includes(txt.toLowerCase()) || 
          item.province.toLowerCase().includes(txt.toLowerCase()) || 
          item.type_name.toLowerCase().includes(txt.toLowerCase()) || 
          item.era_name.toLowerCase().includes(txt.toLowerCase()),
      );
      setListsdata(filteredItems);
      setFilterText('');
  };

  function adjustPage(pg){
    setPage(currentPage => {
        if(currentPage+pg===0){
            return 1;
        }
        if(listsdata.length<=(currentPage + pg - 1)*show){
            return currentPage;
        }
        return currentPage + pg;
    });
  }


  function setLocation(item){
    // setPlace(item);
    gotoURL("/location?id="+item.id);
  }

  const getProvince = (type, id) => {
    let filter = null;
    if(type==="province"){
        all_province.forEach(item => {
            if(parseInt(item.id)===parseInt(id)){
              filter = item;
            }
        });
    }else if(type==="district"){
      all_province.forEach(item => {
          item.amphure.forEach(item => {
            if(parseInt(item.id)===parseInt(id)){
              filter = item;
            }
          });
      });
    }
    // console.log(type, id,filter);
    if(filter){
        return lang(filter.name_th, filter.name_en);
    }else{
        return '';
    }
  }

  return (
    <div className={"container "+styles["place-home"]}>
    <div className={styles["filter-box"]}>
      <FilterComponent onFilter={onFilter} styles={styles} onClear={handleClear} setFilterText={setFilterText} filterText={filterText} export={false} />
    </div>
    <div className={styles["place-lists"]}>
      <ul className={styles["place-ul"]}>
      {(listsdata)?listsdata.map((item, index) => (
          (index>=((page-1)*show)&&index<page*show)?(
          <li key={'location-'+index}>
              <div className={styles["location-card"]} onClick={e=>setLocation(item)}>
                <div className={styles["cover"]}><img src={chk_img(item.img_url)} alt={lang(item.title,item.title)} /></div>
                <div className={styles["location-info"]}>
                    <h4 className={styles["name"]}>{lang(item.name,item.name_en)}</h4>
                      {(parseInt(item.landmark)===0&&item.province&&item.province!=='')?
                      <p className={styles["address"]}>{(item.district)?"อ."+getProvince("district",item.district):''} จ.{getProvince("province",item.province)}</p>
                      :''} 
                      {(parseInt(item.landmark)===1&&item.main_location_province&&item.main_location_province!=='')?
                      <p className={styles["address"]}>{(item.main_location_district)?"อ."+getProvince("district",item.main_location_district):''} จ.{getProvince("province",item.main_location_province)}</p>
                      :''} 
                    <div className={styles["detail"]} dangerouslySetInnerHTML={{__html: lang(item.detail,item.detail_en)}}></div>
                </div>
              </div>
          </li>
          ):''
      )):''}
      </ul>
      <div className={styles["top-menu"]}>
          {(listsdata&&listsdata.length>show)?(
          <div className={styles["btn-group"]}>
              <button onClick={()=>adjustPage(-1)}><i className="fa-solid fa-arrow-left"></i></button>
              <button onClick={()=>adjustPage(1)}><i className="fa-solid fa-arrow-right"></i></button>
          </div>
          ):''}
      </div>
            <div className={styles["readmore"]}>
                <button onClick={() => gotoURL('/location')}>{lang("ดูสถานที่ท่องเที่ยวทั้งหมด","View more")}</button></div>
      <div className={styles["top-menu"]}>
          {/* {(listsdata.length>show)?(
          <div className={styles["btn-group"]}>
              <button onClick={()=>adjustPage(-1)}><i className="fa-solid fa-arrow-left"></i></button>
              <button onClick={()=>adjustPage(1)}><i className="fa-solid fa-arrow-right"></i></button>
          </div>
          ):''} */}
      </div>
    </div>
    </div>
  )
}
